import { render } from "./DropPageForm.vue?vue&type=template&id=3f179321&scoped=true"
import script from "./DropPageForm.vue?vue&type=script&lang=js"
export * from "./DropPageForm.vue?vue&type=script&lang=js"

import "./DropPageForm.vue?vue&type=style&index=0&id=3f179321&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f179321"]])

export default __exports__